module.exports = __webpack_public_path__ + "img/twitter.014c4075.svg";